export default "__VITE_ASSET__01e806e5__"